import { render, staticRenderFns } from "./notes-tab.vue?vue&type=template&id=c6bece30"
import script from "./notes-tab.vue?vue&type=script&lang=js"
export * from "./notes-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports